/* eslint-disable @typescript-eslint/no-explicit-any */
import {useFocusEffect, useNavigation} from '@react-navigation/native';
import {StackNavigationProp} from '@react-navigation/stack';
import React, {useEffect} from 'react';
import {View} from 'react-native';
import {connect} from 'react-redux';
import {Contrat} from '../../../../data/class/contrat';
import {StackParams} from '../../../../data/types/navigation';
import mapDispatchToProps from '../../../../services/redux/mapDispatchToProps';
import mapStateToProps from '../../../../services/redux/mapStateToProps';
import {HeaderScreen} from '../../../components/Header/HeaderScreen';
import {formsStyles} from '../../../components/Inputs/formStyles';
import {Loader} from '../../../components/Loader';
import {NotificationListComponent} from '../../../components/NotificationListComponent';
import {NotificationDescription} from './NotifcationDescription';

const description = 'Vos contrats existant sont affichés ici';

export function MesContratsScreen(props: any) {
  const [isLoading, setLoading] = React.useState(true);
  const [dataList, setDataList] = React.useState<any>([]);
  const {utilisateurContrat, navigation, user} = props;
  const {navigate} =
    useNavigation<StackNavigationProp<StackParams, 'MesContrats'>>();

  const currentUser = user?.data?.utilisateur;
  useFocusEffect(() => {
    if (!currentUser) {
      navigate('Login', {
        data: 'MesContrats',
      });
    }
  });

  const getListContrat = () => {
    utilisateurContrat({}, (res: any) => {
      if (res && res.data && res.data.totalCount > 0) {
        const result = transformContrats(res.data.items);

        setDataList(result);
        setLoading(false);
      } else {
        setLoading(false);
      }
    });
  };

  const transformContrats = (contrats: any) => {
    const result = Array<Contrat>();
    contrats
      .sort((a: any, b: any) => b.id - a.id)
      .forEach((value: any) => {
        result.push(
          new Contrat(
            value.id,
            value.type,
            value.numeroPolice,
            value.is_ending,
            value.isAvenant,
            value.policyNumber,
          ),
        );
      });
    return result;
  };

  useEffect(() => {
    getListContrat();
  }, [navigation.route]);

  return (
    <View style={{flex: 1, flexGrow: 1, width: '100%'}}>
      <HeaderScreen
        title="Compte > Mes contrats"
        type="GoToMonEspace"
        noBreadcrumb={false}
      />
      <View style={formsStyles.webformContainContract}>
        <View
          style={[
            formsStyles.formContainContract,
            formsStyles.contractWrapper,
          ]}>
          <NotificationDescription description={description} />
          {isLoading ? (
            <Loader />
          ) : (
            <NotificationListComponent
              datas={[...dataList].sort(function (a, b) {
                if (a.is_ending === b.is_ending) {
                  if (a.isAvenant === b.isAvenant) {
                    return 0;
                  }
                  return a.isAvenant ? 1 : -1; // sort false first
                }
                return a.is_ending ? -1 : 1;
              })}
              redirectionPage="DetailContrat"
              navigate={navigation.navigate}
            />
          )}
        </View>
      </View>
    </View>
  );
}

export const MesContrats: any = connect(
  mapStateToProps,
  mapDispatchToProps,
)(MesContratsScreen);
